function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './PassportDetails.css';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { forOwn, isEmpty } from 'lodash';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { TextInput, Select, Date as DateField } from './components/FormFields';
import Modal from './components/Modal';
import ActionsPanel from '../ActionsPanel';
import { getDictionaryItem, get } from '../../../../utils';
import { IdndividualProfileInquiry, SaveLongTourismEntryPermit } from '../actions';
import Loader from '../loader';
import { IconWarning } from '../../../atoms/Icons/';
import { searchPasportFieldMapping } from '../constants';
import { format, isValid, parse } from 'date-fns';
const StepRender = props => {
  const {
    context,
    updateContext,
    updateSteps,
    currentStepId,
    stepConfig,
    rtl = false,
    setTranslateValue,
    getTranslateValue,
    generateStepData,
    validateCurrentFields,
    getLookupOptions,
    appRef,
    apiConfig,
    applicationNumber,
    isTranslateAvaible,
    setIsTranslateAvaible,
    setDocuments,
    isLoadingWizard
  } = props;
  const {
    data: {
      title,
      buttonBackUrl,
      availableNationalities,
      pdMessage,
      policyMessage,
      countriesExemptedFromTranslations: {
        targetItems: countriesExemptedFromTranslations
      }
    },
    dictionary,
    validateMessage,
    dictionaryNavigation
  } = stepConfig;
  const PASSPORT_RULES_FIELD = 'passportIssueCountryId';
  const history = useHistory();
  const [requiredRule, setRequiredRule] = useState(false);
  const [errorServerMessage, setErrorServerMessage] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [validateRule, setValidateRule] = useState(false);
  const [validate, setValidate] = useState(false);
  const [validFormPassport, setValidFormPassport] = useState(false);
  const [validForm, setValidForm] = useState(false);
  const [isRequesting, setIsRequesting] = useState(false);
  const [isSendingForm, setIsSendingForm] = useState(false);
  const [passporNotFoundtMessage, setPassporNotFoundtMessage] = useState(false);
  const dashboardUrl = get(buttonBackUrl, 'jss.value.href') || '/';
  const nextStepId = currentStepId + 1;
  const pasportRuleFields = [{
    name: 'passportNo',
    required: true
  }, {
    name: 'passportTypeId',
    required: true
  }, {
    name: 'currentNationalityId',
    required: true
  }, {
    name: 'birthDate',
    required: true
  }, {
    name: PASSPORT_RULES_FIELD,
    required: true
  }];
  const fieldsList = [{
    apiName: 'genderId',
    name: 'Gender',
    type: 'select',
    required: true
  }, {
    apiName: 'lastNameEN',
    name: 'LastName',
    type: 'text',
    required: true,
    relatedFieldName: 'lastNameAR'
  }, {
    apiName: 'lastNameAR',
    name: 'LastNameInArabic',
    type: 'text',
    required: true,
    relatedFieldName: 'lastNameEN'
  }, {
    apiName: 'passportExpiryDate',
    name: 'PassportExpiryDate',
    type: 'date',
    required: true
  }, {
    apiName: 'passportIssueDate',
    name: 'PassportIssueDate',
    type: 'date',
    required: true
  }, {
    apiName: 'passportPlaceAR',
    name: 'PassportPlaceOfIssueInArabic',
    type: 'text',
    required: true,
    relatedFieldName: 'passportPlaceEN'
  }, {
    apiName: 'passportTypeId',
    name: 'PassportType',
    type: 'select',
    required: true,
    selectOptionName: 'passportType'
  }, {
    apiName: 'passportPlaceEN',
    name: 'PassportPlaceOfIssueInEnglish',
    type: 'text',
    required: true,
    relatedFieldName: 'passportPlaceAR'
  }, {
    apiName: 'passportNo',
    name: 'PassportNumber',
    type: 'text',
    required: true
  }, {
    apiName: 'passportIssueCountryId',
    name: 'PassportIssueCountry',
    selectOptionName: 'country',
    type: 'select',
    required: true
  }, {
    apiName: 'firstNameEN',
    name: 'FirstName',
    type: 'text',
    required: true,
    relatedFieldName: 'firstNameAR'
  }, {
    apiName: 'firstNameAR',
    name: 'FirstNameInArabic',
    type: 'text',
    required: true,
    relatedFieldName: 'firstNameEN'
  }, {
    apiName: 'middleNameEN',
    name: 'MiddleName',
    type: 'text',
    required: false,
    relatedFieldName: 'middleNameAR'
  }, {
    apiName: 'middleNameAR',
    name: 'MiddleNameInArabic',
    type: 'text',
    required: false,
    relatedFieldName: 'middleNameEN'
  }, {
    apiName: 'birthDate',
    name: 'DateOfBirth',
    type: 'date',
    required: true
  }, {
    apiName: 'birthPlaceEN',
    name: 'BirthPlaceInEnglish',
    type: 'text',
    required: true,
    relatedFieldName: 'birthPlaceAR'
  }, {
    apiName: 'birthPlaceAR',
    name: 'BirthPlaceInArabic',
    type: 'text',
    required: true,
    relatedFieldName: 'birthPlaceEN'
  }, {
    apiName: 'currentNationalityId',
    name: 'CurrentNationality',
    type: 'select',
    selectOptionName: 'country',
    required: true
  }, {
    apiName: 'previousNationalityId',
    name: 'PreviousNationality',
    type: 'select',
    selectOptionName: 'country',
    required: true,
    staticName: 'Previous Nationality * (static label)'
  }];
  const panelButtonState = {
    continue: {
      inactive: !validForm,
      loading: isLoadingWizard,
      label: getDictionaryItem(dictionaryNavigation, 'NavigationContinue')
    },
    back: {
      inactive: false,
      label: getDictionaryItem(dictionaryNavigation, 'NavigationBack')
    },
    save: {
      inactive: !(applicationNumber && applicationNumber.length && validForm),
      loading: isSendingForm,
      label: getDictionaryItem(dictionaryNavigation, 'NavigationSave')
    }
  };
  const panelActions = {
    contionueAction: () => {
      if (openModal()) return;
      updateSteps(nextStepId);
    },
    saveAction: async () => {
      if (applicationNumber && applicationNumber.length) {
        if (validateCurrentFields && validateCurrentFields(fieldsList)) {
          setValidate(true);
          return;
        }
        await submitData(false, applicationNumber);
      }
    },
    backAction: () => {
      history.push(dashboardUrl);
    }
  };
  const submitData = async (isDraft, appId) => {
    setErrorServerMessage('');
    setIsSendingForm(true);
    const {
      applicationNumber = '',
      documents = [],
      isSuccess = false,
      error
    } = await SaveLongTourismEntryPermit(apiConfig, context, isDraft, appId);
    console.log('error', error);
    setIsSendingForm(false);
    if (!isEmpty(error)) {
      const errorMessage = rtl && error.ar ? error.ar : error.en || '';
      setErrorServerMessage(errorMessage.replaceAll(',', '\n'));
      return false;
    }
    if (isSuccess && applicationNumber.length) {
      setDocuments(documents);
      return true;
    }
    return false;
  };
  const resetFormData = () => {
    forOwn(context, item => {
      const {
        name = '',
        required
      } = item;
      const passportItem = pasportRuleFields.find(_ref => {
        let {
          name: passportFieldName
        } = _ref;
        return passportFieldName === name;
      });
      if (passportItem) return;
      updateContext({
        [name]: _objectSpread(_objectSpread({}, item), {}, {
          value: '',
          valid: !required
        })
      });
    });
  };
  const validateRequiredRule = async () => {
    if (validateCurrentFields && validateCurrentFields(pasportRuleFields)) {
      setValidateRule(true);
      return;
    }
    if (openModal()) return;
    resetFormData();
    const translateCheck = checkAvaibleTranslantation();
    setIsTranslateAvaible(translateCheck);
    setIsRequesting(true);
    const {
      data,
      status
    } = await IdndividualProfileInquiry(apiConfig, context);
    if (isEmpty(data) || status !== 200) setPassporNotFoundtMessage(true);else setPassporNotFoundtMessage(false);
    forOwn(data, (value, fieldName) => {
      let name = fieldName;
      let computedValue = value;
      if (value.id) {
        name = fieldName + 'Id';
        computedValue = value.id;
      }
      let apiName = name;
      if (!searchPasportFieldMapping[name]) return;
      apiName = searchPasportFieldMapping[name] || name;
      if (apiName === 'birthDate' && !isValid(new Date(computedValue.replaceAll('-', '/')))) {
        computedValue = format(parse('27-02-2000', 'dd-MM-yyyy', new Date()), 'yyyy-MM-dd');
      }
      updateContext({
        [apiName]: _objectSpread(_objectSpread({}, context[apiName]), {}, {
          value: computedValue,
          valid: true
        })
      });
    });
    setIsRequesting(false);
    setRequiredRule(true);
  };
  const getCurrentOptionCountry = () => {
    const item = context[PASSPORT_RULES_FIELD];
    const selectOptionName = item.selectOptionName;
    const options = getLookupOptions && getLookupOptions(selectOptionName) || [];
    return options.find(_ref2 => {
      let {
        lookupId
      } = _ref2;
      return String(lookupId) === String(item.value);
    });
  };
  const checkAvaibleTranslantation = () => {
    const {
      lookupId = 'null'
    } = getCurrentOptionCountry();
    return !countriesExemptedFromTranslations.find(_ref3 => {
      let {
        key: {
          value = ''
        }
      } = _ref3;
      return String(value) === String(lookupId);
    });
  };
  const openModal = () => {
    const currentOption = getCurrentOptionCountry();
    const checkCurrentCountry = availableNationalities.find(_ref4 => {
      let {
        countryName: {
          jss: {
            value = ''
          }
        }
      } = _ref4;
      return value.toLowerCase() === (rtl ? currentOption.name.ar.toLowerCase() : currentOption.name.en.toLowerCase());
    });
    if (!checkCurrentCountry) {
      setShowModal(true);
      return true;
    }
    return false;
  };
  useEffect(() => {
    generateStepData && generateStepData(fieldsList, dictionary);
    appRef && appRef.current.scrollIntoView({
      behavior: 'smooth'
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (validForm) setRequiredRule(true);
  }, [validForm]);
  useEffect(() => {
    applicationNumber && applicationNumber.length && setRequiredRule(true);
  }, [applicationNumber]);
  useEffect(() => {
    if (validateCurrentFields && !validateCurrentFields(fieldsList)) setValidForm(true);else setValidForm(false);
    if (validateCurrentFields && !validateCurrentFields(pasportRuleFields)) setValidFormPassport(true);else setValidFormPassport(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context]);
  return /*#__PURE__*/React.createElement("div", {
    className: ` ${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "wizard__body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row "
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h2",
    className: 'h2',
    field: title || {
      value: ''
    }
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "module-group-app module-group-app--inside"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6 form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['passportTypeId'], {
    updateContext: updateContext,
    validate: validateRule,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('passportType') || [],
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4  col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    rtl: rtl
  }, context['passportNo'], {
    updateContext: updateContext,
    validate: validateRule,
    patternInvalidMessage: validateMessage,
    patternRegex: /^(?!^0+$)[a-zA-Z0-9]{3,20}$/
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4  col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['currentNationalityId'], {
    updateContext: updateContext,
    validate: validateRule,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('country') || [],
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4  col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(DateField, _extends({
    dateFormat: "yyyy-mm-dd"
  }, context['birthDate'], {
    updateContext: updateContext,
    validate: validateRule,
    patternInvalidMessage: validateMessage,
    rtl: rtl,
    isOnlyPast: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4  col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['passportIssueCountryId'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('country') || [],
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4  col-md-6 form-field form-button"
  }, /*#__PURE__*/React.createElement("button", {
    className: `btn btn-primary ${isLoadingWizard || !validFormPassport ? 'disabled' : ''}`,
    onClick: validateRequiredRule
  }, isRequesting ? /*#__PURE__*/React.createElement(Loader, null) : getDictionaryItem(dictionary, 'SearchPassportData') || 'Search passport data')), passporNotFoundtMessage && /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "message"
  }, /*#__PURE__*/React.createElement(IconWarning, null), /*#__PURE__*/React.createElement(RichText, {
    field: _objectSpread({}, get(pdMessage, 'jss'))
  }))), requiredRule && /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    setTranslateValue: setTranslateValue
  }, context['firstNameEN'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    isTranslateAvaible: isTranslateAvaible,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    getTranslateValue: getTranslateValue,
    updateContext: updateContext
  }, context['firstNameAR'], {
    validate: validate,
    patternInvalidMessage: validateMessage,
    isTranslateAvaible: isTranslateAvaible,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['genderId'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('gender') || [],
    isString: true,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    setTranslateValue: setTranslateValue
  }, context['middleNameEN'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    isTranslateAvaible: isTranslateAvaible,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    rtl: rtl,
    getTranslateValue: getTranslateValue,
    updateContext: updateContext
  }, context['middleNameAR'], {
    validate: validate,
    patternInvalidMessage: validateMessage,
    isTranslateAvaible: isTranslateAvaible
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['previousNationalityId'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('country') || [],
    isString: true,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    setTranslateValue: setTranslateValue
  }, context['lastNameEN'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    isTranslateAvaible: isTranslateAvaible,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    getTranslateValue: getTranslateValue,
    updateContext: updateContext
  }, context['lastNameAR'], {
    validate: validate,
    patternInvalidMessage: validateMessage,
    isTranslateAvaible: isTranslateAvaible,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(DateField, _extends({
    rtl: rtl
  }, context['passportIssueDate'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    isOnlyPast: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    setTranslateValue: setTranslateValue
  }, context['birthPlaceEN'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    isTranslateAvaible: isTranslateAvaible,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    getTranslateValue: getTranslateValue,
    updateContext: updateContext
  }, context['birthPlaceAR'], {
    validate: validate,
    patternInvalidMessage: validateMessage,
    isTranslateAvaible: isTranslateAvaible,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(DateField, _extends({}, context['passportExpiryDate'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    rtl: rtl,
    isOnlyFuture: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    setTranslateValue: setTranslateValue
  }, context['passportPlaceEN'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    isTranslateAvaible: isTranslateAvaible,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    getTranslateValue: getTranslateValue,
    updateContext: updateContext
  }, context['passportPlaceAR'], {
    validate: validate,
    patternInvalidMessage: validateMessage,
    isTranslateAvaible: isTranslateAvaible,
    rtl: rtl
  })))))), errorServerMessage.length ? /*#__PURE__*/React.createElement("div", {
    className: "error-message"
  }, errorServerMessage) : ''), requiredRule && /*#__PURE__*/React.createElement("div", {
    className: "module-group-wrap"
  }, /*#__PURE__*/React.createElement(RichText, {
    field: get(policyMessage, 'jss'),
    className: "field__info"
  }))), /*#__PURE__*/React.createElement(ActionsPanel, {
    rtl: rtl,
    actions: panelActions,
    buttonState: panelButtonState
  }), showModal && /*#__PURE__*/React.createElement(Modal, {
    hide: () => setShowModal(false),
    rtl: rtl,
    dictionary: _objectSpread(_objectSpread({}, stepConfig.data), dictionary),
    apiConfig: apiConfig,
    context: context
  }));
};
const commonStyles = "c194ida3";
const rtlStyles = "rbmmieg";
const ltrStyles = "l9sigek";
export default StepRender;